import { FunctionComponent } from "react";

import {
  QueryStateIndicator,
  QueryStateIndicatorProps
} from "../common/ui-components/QueryStateIndicator";
import {
  ComponentCode,
  TenantFeaturesCode
} from "./gateways/plt-catalog/plt-catalog.dtos";
import {
  usePltCatalogPracticeLicences,
  usePltcCatalogComponent,
  useTenantFeatures
} from "./gateways/plt-catalog/plt-catalog.hooks";
import { useCurrentUserQuery } from "./gateways/user/UserHooks";
import { UserDto } from "./models";

export const CoreDataFetcher: FunctionComponent<
  Pick<QueryStateIndicatorProps<UserDto>, "children">
> = props => {
  const userQuery = useCurrentUserQuery();
  const { isLoading: isTenantFeatureLoading, error: tenantFeatureError } =
    useTenantFeatures(TenantFeaturesCode.prosBhbIntegration);

  const {
    isLoading: isPltCatalogPracticeLicencesLoading,
    error: pltCatalogPracticeLicencesError
  } = usePltCatalogPracticeLicences();

  const { isLoading: isTenantComponentLoading, error: tenantComponentError } =
    usePltcCatalogComponent(ComponentCode.bpmIntegration);

  return (
    <QueryStateIndicator
      loadingTitle="Loading your profile, please wait..."
      isLoading={
        isTenantFeatureLoading ||
        userQuery.isLoading ||
        isPltCatalogPracticeLicencesLoading ||
        isTenantComponentLoading
      }
      error={
        tenantFeatureError ||
        userQuery.error ||
        pltCatalogPracticeLicencesError ||
        tenantComponentError
      }
      data={userQuery.data}
      {...props}
    />
  );
};
